/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contracts_HintInputs */

const cs_contracts_hint = /** @type {(inputs: Contracts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smlouvy navázané na nemovitost.`)
};

const en_contracts_hint = /** @type {(inputs: Contracts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing and deal contracts linked to this property.`)
};

/**
* | output |
* | --- |
* | "Listing and deal contracts linked to this property." |
*
* @param {Contracts_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contracts_hint = /** @type {((inputs?: Contracts_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contracts_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contracts_hint(inputs)
	return cs_contracts_hint(inputs)
});